import React from 'react';
import { Helmet } from 'react-helmet';

const MessageRecover = () => {
  const PUBLIC_URL= "./messageRecoveryFavicon.png"
  const PUBLIC_URL_ICO= "./messageRecoveryFavicon.ico"
  const styles = {
    body: {
      fontFamily: 'Arial, sans-serif',
      backgroundColor: '#373e46',
      color: 'white',
      lineHeight: '1.6',
      margin: 0,
      padding: 0,
    },
    header: {
      backgroundColor: '#2c3239',
      padding: '20px',
      textAlign: 'center',
      fontSize: '24px',
      fontWeight: 'bold',
    },
    container: {
      padding: '30px',
      maxWidth: '800px',
      margin: 'auto',
      backgroundColor: '#444b53',
      borderRadius: '8px',
      boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
    },
    h1: {
      color: '#f1c40f',
    },
    h2: {
      color: '#f1c40f',
    },
    h3: {
      color: '#f1c40f',
    },
    p: {
      fontSize: '16px',
    },
    ul: {
      margin: '20px 0',
      paddingLeft: '20px',
    },
    li: {
      marginBottom: '10px',
    },
    footer: {
      backgroundColor: '#2c3239',
      textAlign: 'center',
      padding: '15px',
      position: 'fixed',
      bottom: 0,
      width: '100%',
    },
  };

  return (
    <div style={styles.body}>
    
  <link rel="icon" href="./messageRecoveryFavicon.ico" type="image/x-icon" />
  <link rel="apple-touch-icon" href="./messageRecoveryFavicon.png" />
  <meta name="msapplication-TileImage" content= "./messageRecoveryFavicon.png" />
      <Helmet>
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
        <title>Privacy Policy - Savariya IT Solutions</title>
        <script
          async
          src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4691049341608206"
          crossOrigin="anonymous"
        ></script>
      </Helmet>

      <header style={styles.header}>Privacy Policy - Savariya IT Solutions</header>

      <div style={styles.container}>
        <h1 style={styles.h1}>Introduction</h1>
        <p>
          At Savariya IT Solutions, we are committed to protecting your privacy. This Privacy Policy outlines how we
          collect, use, and share your personal information when you use our mobile applications (available for both
          Android and iOS). By using our services, you agree to the practices described in this policy.
        </p>

        <h2 style={styles.h2}>What Information We Collect</h2>
        <h3 style={styles.h3}>Personal Information</h3>
        <p>
          We may collect personal information to provide a better user experience. This information includes:
        </p>
        <ul style={styles.ul}>
          <li>Details from social networks (e.g., email, profile picture)</li>
          <li>Device information (e.g., gallery pictures, app usage data)</li>
          <li>Your feedback and communication with us (e.g., email, names)</li>
        </ul>

        <h3 style={styles.h3}>Non-Personal Information</h3>
        <p>
          We also collect non-personal data to improve the functionality of our services. This includes:
        </p>
        <ul style={styles.ul}>
          <li>App usage data</li>
          <li>Device-related information (e.g., type, operating system)</li>
        </ul>

        <h2 style={styles.h2}>How We Use Your Information</h2>
        <p>We use the information we collect to:</p>
        <ul style={styles.ul}>
          <li>Personalize your experience and provide relevant services</li>
          <li>Enhance and improve the performance of our apps</li>
          <li>Send you notifications and updates related to the service</li>
          <li>Assist with troubleshooting and support</li>
        </ul>

        <h2 style={styles.h2}>How We Protect Your Information</h2>
        <p>
          We take the security of your information seriously. We implement measures to safeguard your non-personal data,
          such as:
        </p>
        <ul style={styles.ul}>
          <li>Data encryption and secure communication protocols</li>
          <li>Restricted access to your information on our servers</li>
        </ul>
        <p>
          However, please understand that no security system is completely foolproof. While we strive to protect your
          data, we cannot guarantee absolute security.
        </p>

        <h2 style={styles.h2}>Sharing Your Information</h2>
        <h3 style={styles.h3}>Personal Information</h3>
        <p>
          We do not store or share any personal information such as your name, email address, or other identifiable data.
        </p>

        <h3 style={styles.h3}>Non-Personal Information</h3>
        <p>
          We may share non-personal information with trusted partners for marketing and promotional purposes, but
          this will always be in accordance with privacy laws.
        </p>

        <h2 style={styles.h2}>Third-Party Links</h2>
        <p>
          Our apps may contain links to third-party websites or services. Please note that we are not responsible for
          the privacy practices of these third parties. We encourage you to review the privacy policies of any third-party
          sites you visit.
        </p>

        <h2 style={styles.h2}>Your Rights and Choices</h2>
        <p>
          You have the right to access, update, and delete the information we collect from you. If you wish to exercise
          any of these rights, please contact us through the provided email address.
        </p>

        <h2 style={styles.h2}>Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. When we do, we will post the updated policy on this page,
          along with the date of the last revision. We encourage you to review this policy periodically to stay informed.
        </p>

        <h2 style={styles.h2}>Contact Us</h2>
        <p>
          If you have any questions or concerns regarding this Privacy Policy, or if you need assistance, please feel
          free to contact us via email.
        </p>
      </div>

      <footer style={styles.footer}>
        <p>&copy; 2025 Savariya IT Solutions. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default MessageRecover;
